import { useState } from "react";
import { AgentSkillKind } from "@common/types/agentSkill";
import { Drawer } from "@design-system/Drawer/Drawer";
import { AgentSkillEditorForm } from "./AgentSkillEditorForm";
import { AgentSkillFormFields } from "./AgentSkillFormFields";
import { AgentSkillFormValues } from "./agentSkillForm";
import styles from "./AgentSkills.module.scss";

interface Props {
    title: string;
    submitLabel: string;
    initialValues: AgentSkillFormValues;
    clientName: string | null;
    kind?: AgentSkillKind;
    tools?: string[];
    /** Resolves to the validator's warnings, or nothing when no save happened. */
    onSubmit: (values: AgentSkillFormValues) => Promise<string[] | void>;
    onClose: () => void;
}

export const AgentSkillEditorDrawer = ({
    title,
    submitLabel,
    initialValues,
    clientName,
    kind,
    tools,
    onSubmit,
    onClose,
}: Props) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <Drawer
            open
            onClose={isSubmitting ? undefined : onClose}
            size="half"
            headerAddonLeft={<h2 className={styles.drawerTitle}>{title}</h2>}
        >
            <AgentSkillEditorForm
                className={styles.editorForm}
                submitLabel={submitLabel}
                initialValues={initialValues}
                kind={kind}
                onSubmit={(values) => {
                    setIsSubmitting(true);
                    return onSubmit(values).finally(() =>
                        setIsSubmitting(false),
                    );
                }}
                onClose={onClose}
            >
                <AgentSkillFormFields
                    clientName={clientName}
                    kind={kind ?? AgentSkillKind.FIRM}
                    tools={tools ?? []}
                />
            </AgentSkillEditorForm>
        </Drawer>
    );
};
